<template>
	<li :class="className">
		<a class="dropdown-link" @click="onClick(idx, name)">
			<span class="dropdown-link__content">
				<span class="d-flex">
					<img v-if="img" :src="img" :alt="img">

					<span class="icon history-block-icon"
						  v-if="icon"
						  :class="'icon-' + icon"
					/>

					<flag v-if="flag" :iso="flag" />
				</span>

				<span
					v-if="prependIcon"
					class="dropdown__prepend__icon"
				>
					<span>{{ prependIcon }}</span>
				</span>

				<template v-if="accountItem">
					<span class="dropdown-lang-link-block">
						<span class="card__blocked" v-if="state === 4">{{ $t("companyAccounts.bills.cardBlocked") }}</span>
						<span class="title color-gray" v-if="text">{{ text }}</span>
						<span class="text color-gray" v-if="name">{{ name }}</span>
						<span class="bottom ml-0" v-if="amount">{{ amount }}</span>
					</span>
				</template>

				<template v-else>
					<span class="dropdown-link-block">
						<span class="dropdown-link-name" v-if="score">{{ score }}</span>
						<span class="dropdown-link-name" v-if="namePropVisibility">
							{{ name }}
							<span v-if="card">{{ card }}</span>
						</span>
						<span class="dropdown-link-name" v-if="number">{{ number }}</span>
						<span class="dropdown-link-name" v-if="props">{{ props }}</span>
						<span class="dropdown-link-price" v-if="price">{{ price }}</span>
						<span class="dropdown-link-name" v-if="subPrice">{{ subPrice }}</span>
					</span>
				</template>

				<span class="dropdown-lang-link-block ml-auto" v-if="mfo">
					<span class="text color-gray nowrap">{{ `${mfo}` }}</span>
				</span>

				<IBStaticBadge
					v-if="showCount"
					class="dropdown__badge"
					:text="count"
				/>
			</span>

			<IBCircleCheckbox
				v-if="isActive && showCheckIcon"
				v-model="checked"
				class="list-item__check"
				disabled
			/>
		</a>
	</li>
</template>

<script>

import Vue from "vue";
import Flag from "../Flags/Flag";
import IBCircleCheckbox from "@/components/IBCheckbox/IBCircleCheckbox";
import IBStaticBadge from "@/components/IBBadge/IBStaticBadge";

export default Vue.extend({
	name: "DropdownList",
	components: {
		Flag,
		IBCircleCheckbox,
		IBStaticBadge,
	},
	props: {
		className: {
			type: String,
			default: ""
		},
		namePropVisibility: {
			type: Boolean,
			default: true
		},
		showCount: {
			type: Boolean,
			default: false
		},
		accountItem: {
			type: Boolean,
			default: false
		},
		idx: {
			type: Number,
			default: 0
		},
		state: {
			type: Number,
			default: 0
		},
		count: {
			type: Number,
			default: 0
		},
		img: {
			type: String,
			default: ""
		},
		showCheckIcon: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: ""
		},
		flag: {
			type: String,
			default: ""
		},
		score: {
			type: String,
			default: ""
		},
		name: {
			type: String,
			default: ""
		},
		card: {
			type: String,
			default: ""
		},
		number: {
			type: String,
			default: ""
		},
		props: {
			type: String,
			default: ""
		},
		price: {
			type: String,
			default: ""
		},
		subPrice: {
			type: String,
			default: ""
		},
		text: {
			type: String,
			default: ""
		},
		amount: {
			type: String,
			default: ""
		},
		mfo: {
			type: String,
			default: ""
		},
		prependIcon: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			checked: true
		};
	},
	methods: {
		onClick(idx, value) {
			this.$emit("click", idx, value);
		}
	},
	computed: {
		isActive() {
			return this.className?.indexOf('active') > -1;
		}
	}
});

</script>

<style lang="sass" scoped>

@import "../../assets/style/core/functions"

.card__blocked
	font-size: 14px
	line-height: 20px
	color: #DE3730

.dropdown-link,
.dropdown-link__content
	display: flex
	align-items: center
	width: 100%
	// min-width: 400px
	min-width: 264px

.dropdown-link
	justify-content: space-between
	min-height: 42px

.dropdown
	&__badge
		margin-left: 20px
		margin-right: 12px

.list-item
	&__check
		width: 24px
		height: 24px

</style>

<style lang="sass">

.list-item
	&__check
		> .checkbox-inner
			width: 24px
			height: 24px

</style>